import React from 'react'
import { Element } from 'react-scroll'
import { Link } from 'react-router-dom'
import { Link as ScrollTo } from 'react-scroll'
import SectionTitle2 from '../sectionTitle/SectionTitle2'

const CoreOfferings = () => {
  return (
    <>
      <Element
        name="CoreOfferings"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Core Offerings"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Bridging the gap between innovation and implementation with our comprehensive AI solutions.</p>
            </div>
            <div className="col-12 col-lg-3 px-0 px-md-4 mt-4 mt-md-5">
              <div className="home-applied-ai-solutions-card p-4 h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/brain.svg`} alt="brain" />
                </div>
                <h5 className="mt-3 mb-3">Applied AI Solutions</h5>
                <p>Specialized solutions including Predictive Analytics, Generative AI, Anomaly Detection, Sentiment Analysis, and NLP.</p>
                <ScrollTo className="cursor-pointer d-flex flex-row align-items-center justify-content-start gap-2 home-links" to="HomeAppliedAISolutions">Learn more<i className="icon-arrow-right-line-right"></i></ScrollTo>
              </div>
            </div>
            <div className="col-12 col-lg-3 px-0 px-md-4 mt-4 mt-md-5">
              <div className="home-applied-ai-solutions-card p-4 h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/server.svg`} alt="server" />
                </div>
                <h5 className="mt-3 mb-3">Edge AI Products</h5>
                <p>Modular, low-power Edge AI hardware and solutions for real-time, on-site intelligence across industries.</p>
                <Link className="d-flex flex-row align-items-center justify-content-start gap-2 home-links" to="/products/m2m-edge-ai">Learn more<i className="icon-arrow-right-line-right"></i></Link>
              </div>
            </div>
            <div className="col-12 col-lg-3 px-0 px-md-4 mt-4 mt-md-5">
              <div className="home-applied-ai-solutions-card p-4 h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/users.svg`} alt="users" />
                </div>
                <h5 className="mt-3 mb-3">Workforce Development</h5>
                <p>Programs like DataTalent, AIWorks, and AI Ready, with cohort-based e-learning, work-integrated learning & Career wraparound.</p>
                <ScrollTo className="cursor-pointer d-flex flex-row align-items-center justify-content-start gap-2 home-links" to="HomeWorkforceDevelopment">Learn more<i className="icon-arrow-right-line-right"></i></ScrollTo>
              </div>
            </div>
            <div className="col-12 col-lg-3 px-0 px-md-4 mt-4 mt-md-5">
              <div className="home-applied-ai-solutions-card p-4 h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/rocket.svg`} alt="rocket" />
                </div>
                <h5 className="mt-3 mb-3">Business Accelerator</h5>
                <p>Supporting startups and enterprises to commercialize AI ideas into scalable products, from proof of concept to funding.</p>
                <Link className="d-flex flex-row align-items-center justify-content-start gap-2 home-links" to="/programs/business-accelerator">Learn more<i className="icon-arrow-right-line-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default CoreOfferings;